<template>
  <div>
    <payments-charge-off-modal :payments-charge-off-to-invoice-cb="paymentsChargeOffToInvoice"/>
    <div class="d-flex justify-content-end button-group">
      <b-btn variant="primary" @click="openChargeOffModal" :disabled="isInvoiceChargedOff" size="sm">
        {{$t('buttons.payments.charge_off_money')}}
      </b-btn>
      <b-btn variant="secondary" @click="cancelChargeOff" :disabled="!isInvoiceChargedOff" size="sm">
        {{$t('buttons.payments.cancel_charge_off')}}
      </b-btn>
    </div>
  </div>
</template>
<script>
import PaymentsChargeOffModal from '@/components/modals/PaymentsChargeOffModal'
import { notificationsRenderer } from '@/helpers/renderHelpers'
export default {
  name: "SaleAgentInvoiceChargeOffs",
  components: {
    PaymentsChargeOffModal
  },
  props: {
    invoiceData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isInvoiceChargedOff() {
      return this.invoiceData.balance === 0;
    },
  },
  methods: {
    paymentsChargeOffToInvoice (data) {
      console.log(data)
      console.log(this.invoiceData)
      // this.$http.post(`${this.commonUrl}charge_off_balance/`, data)
      //     .then(async () => {
      //       await this.fetchInvoiceData();
      //       await this.fetchPayments();
      //       this.currentTabName = 'payments';
      //     }).catch(error => notificationsRenderer(error.data, 'error'));
    },
    openChargeOffModal() {
      this.$root.$emit('openPaymentsChargeOffModal');
    },
    async cancelChargeOff() {
      console.log(this.invoiceData)
      // await this.$http.post(`${this.commonUrl}cancel_charge_off/`);
      // await this.fetchInvoiceData();
      // await this.fetchPayments();
      // this.currentTabName = 'payments';
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/sale-agent-invoice/SaleAgentInvoiceChargeOffs.vue